export const digits = (s: string) => s.replace(/[^0-9]/g, "");

export const enDash = "â€“";

export const isNullOrWhitespace = (x: string | undefined | null | false) => {
	return !x || !/\S/.test(x);
};

export const enDashWhenNullOrWhiteSpace = (x: string | undefined | null | false): string => {
	if (!x || isNullOrWhitespace(x)) {
		return enDash;
	}

	return x;
};

export const ensureIsNotNullOrWhitespace = (x: string | undefined | null | false): string => {
	if (isNullOrWhitespace(x)) {
		throw new Error();
	}
	return x as string;
};

export const digitsOnly = (string: string) =>
	string
		.split("")
		.filter(char => /\d/.test(char))
		.join("");

export const hasHtmlEncodedHtmlTags = (text: string): boolean => {
	const htmlEncodedElementPattern = /&lt;\/?[a-zA-Z][\s\S]*?&gt;/;
	return htmlEncodedElementPattern.test(text);
};

// Conservative heuristics to detect actual markdown markers while avoiding false positives such as IMG_6154
const markdownIndicators: RegExp[] = [
	/\*\*[^*\n]+\*\*/, // Bold
	/\[[^\]]+\]\([^\)]+\)/, // Links
	/(^|\n)#{1,6}\s+\S+/, // Headings
];

export const hasMarkdownText = (text: string): boolean => {
	return markdownIndicators.some(pattern => pattern.test(text));
};
